import CryptoJS from 'crypto-js';
const SECRET_KEY = 'D#4436Bqe2$%$#$%MC&^$@#^*&%I'
// Encrypt
export const encryptdata=(value)=> {
    return CryptoJS.AES.encrypt(value, 'SAJhhjvadsv$#W54weydcfR#WT').toString();
  }

  export const decryptdata=(value)=> {
      if(value){
          return CryptoJS.AES.decrypt(value, "SAJhhjvadsv$#W54weydcfR#WT").toString(CryptoJS.enc.Utf8);
      }
   
  }

export const encrypt= (data) => {
    let ciphertext = CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
    return ciphertext;
}

  export const decrypt= (data) => {
    if(data){
    var bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData;
    }
  }